<template>
	<div class="index">
		<keep-alive>
			<transition :name="transitionName">
				<router-view v-if="$route.meta.keepAlive"></router-view>
			</transition>
		</keep-alive>
		<transition :name="transitionName">
			<router-view v-if="!$route.meta.keepAlive"></router-view>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				transitionName: '', // 设置初始过渡效果
			};
		},
		watch: {
			// 监听路由变化
			'$route'(to, from) {
				// 根据路由变化方向设置过渡效果
				this.transitionName = to.meta.transitionName || '';
			},
		},
		methods: {
		},
	}
</script>

<style>
	/* CSS 过渡效果 */
	.slide-left-enter-active,
	.slide-left-leave-active,
	.slide-right-enter-active,
	.slide-right-leave-active {
		transition: transform 0.3s ease-in-out;
	}

	.slide-left-enter,
	.slide-right-leave-to {
		transform: translateX(100%);
	}

	.slide-left-leave-to,
	.slide-right-enter {
		transform: translateX(-100%);
	}

	.router-view {
		position: absolute;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
</style>



// WEBPACK FOOTER //
// src/components/routerIndex.vue